import type { LeadCloudFileType, TaskAnswerType, TaskCardType } from '@econtractor/types';

/** Розділяє cloud-файли задачі на файли задачі vs відповіді за task_answer.fileKeys (лише UI). */
export const splitTaskFilesByAnswer = (
    allFiles: LeadCloudFileType[] | null | undefined,
    taskAnswer?: TaskAnswerType | null,
): { files: LeadCloudFileType[]; answerFiles: LeadCloudFileType[] } => {
    const list = Array.isArray(allFiles) ? allFiles : [];
    const keySet = new Set(
        Array.isArray(taskAnswer?.fileKeys) ? taskAnswer.fileKeys.filter(Boolean) : [],
    );
    if (!keySet.size) {
        return { files: list, answerFiles: [] };
    }
    const files: LeadCloudFileType[] = [];
    const answerFiles: LeadCloudFileType[] = [];
    for (const file of list) {
        if (keySet.has(file.storageKey)) answerFiles.push(file);
        else files.push(file);
    }
    return { files, answerFiles };
};

export const getTaskCardFileBuckets = (task: TaskCardType) =>
    splitTaskFilesByAnswer(task.files, task.taskAnswer);
